<!-- Корневой компонент. Восстановление сессии (authStore.bootstrap) — в Stage 2. -->
<template>
  <router-view />
</template>

<style>
#app {
  min-height: 100vh;
  background: var(--color-bg-page, #f5f7fa);
}
</style>
